import { Action, combineReducers } from "@reduxjs/toolkit";

import {
	executors,
	globalStateExecutorsAction,
	StateExecutors,
} from "./Executors";
import {
	executorLocations,
	globalStateExecutorLocationsAction,
	StateExecutorLocations,
} from "./ExecutorLocations";
import {
	executorGroup,
	globalStateExecutorGroupAction,
	StateExecutorGroup,
} from "./ExecutorGroup";
import {
	executorRate,
	globalStateExecutorRateAction,
	StateExecutorRate,
} from "./ExecutorRate";
import {
	customerBalanceRule,
	globalStateCustomerBalanceRuleAction,
	StateCustomerBalanceRule,
} from "./CustomerBalanceRule";
import {
	executorPenalty,
	globalStateExecutorPenaltyAction,
	StateExecutorPenalty,
} from "./ExecutorPenalty";
import {
	executorRating,
	globalStateExecutorRatingAction,
	StateExecutorRating,
} from "./ExecutorRating";
import {
	dispatcherRate,
	globalStateDispatcherRateAction,
	StateDispatcherRate,
} from "./DispatcherRate";
import { role, globalStateRoleAction, StateRole } from "./Role";
import {
	carSectors,
	globalStateCarSectorsAction,
	StateCarSectors,
} from "./CarSectors";
import { carPark, globalStateCarParkAction, StateCarPark } from "./CarPark";
import {
	multySelectModals,
	globalStateMultySelectModalsAction,
	StateMultySelectModals,
} from "./MultySelectModals";
import {
	priceZones,
	globalStatePriceZoneAction,
	StatePriceZone,
} from "./PriceZone";
import { parking, globalStateParkingAction, StateParking } from "./Parking";
import { GlobalState } from "./interface";

export { GlobalState };

export type State = {
	carSectors: StateCarSectors;
	carPark: StateCarPark;
	executors: StateExecutors;
	executorLocations: StateExecutorLocations;
	executorGroup: StateExecutorGroup;
	executorRate: StateExecutorRate;
	customerBalanceRule: StateCustomerBalanceRule;
	executorPenalty: StateExecutorPenalty;
	executorRating: StateExecutorRating;
	dispatcherRate: StateDispatcherRate;
	role: StateRole;
	multySelectModals: StateMultySelectModals;
	priceZones: StatePriceZone;
	parking: StateParking;
};

export type Actions = {
	carSectors: typeof globalStateCarSectorsAction;
	carPark: typeof globalStateCarParkAction;
	executors: typeof globalStateExecutorsAction;
	executorLocations: typeof globalStateExecutorLocationsAction;
	executorGroup: typeof globalStateExecutorGroupAction;
	executorRate: typeof globalStateExecutorRateAction;
	customerBalanceRule: typeof globalStateCustomerBalanceRuleAction;
	executorPenalty: typeof globalStateExecutorPenaltyAction;
	executorRating: typeof globalStateExecutorRatingAction;
	dispatcherRate: typeof globalStateDispatcherRateAction;
	role: typeof globalStateRoleAction;
	multySelectModals: typeof globalStateMultySelectModalsAction;
	priceZones: typeof globalStatePriceZoneAction;
	parking: typeof globalStateParkingAction;
};

export const globalStateReducer = combineReducers<State, Action<Actions>>({
	carSectors,
	carPark,
	executors,
	executorLocations,
	executorGroup,
	executorRate,
	customerBalanceRule,
	executorPenalty,
	executorRating,
	dispatcherRate,
	role,
	multySelectModals,
	priceZones,
	parking,
});

export const globalStateAction: Actions = {
	carSectors: globalStateCarSectorsAction,
	carPark: globalStateCarParkAction,
	executors: globalStateExecutorsAction,
	executorLocations: globalStateExecutorLocationsAction,
	executorGroup: globalStateExecutorGroupAction,
	executorRate: globalStateExecutorRateAction,
	customerBalanceRule: globalStateCustomerBalanceRuleAction,
	executorPenalty: globalStateExecutorPenaltyAction,
	executorRating: globalStateExecutorRatingAction,
	dispatcherRate: globalStateDispatcherRateAction,
	role: globalStateRoleAction,
	multySelectModals: globalStateMultySelectModalsAction,
	priceZones: globalStatePriceZoneAction,
	parking: globalStateParkingAction,
};

export default globalStateReducer;
